import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDeferredNavigation } from "../contexts/DeferredNavigationContext";

/** Scroll to top when the displayed page changes, not when the URL updates during deferred prefetch. */
export default function ScrollToTopOnNavigate() {
  const liveLocation = useLocation();
  const deferred = useDeferredNavigation();
  const { pathname, hash } = deferred?.displayLocation || liveLocation;

  useEffect(() => {
    if (hash) return;

    window.scrollTo(0, 0);
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
  }, [pathname, hash]);

  return null;
}
